<template>
  <el-row>
    <el-col :span="8">
      <h6>Total</h6>
    </el-col>
    <el-col :span="4" :offset="12" class="text-right">
      {{ total | currency }}
    </el-col>
  </el-row>
</template>

<script>
import {currency} from '../../../../filters';

export default {
  name: 'OrderUpdatePaymentTotal',
  filters: {
    currency,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
  },
};
</script>
